<script lang="ts">
    import {createEventDispatcher} from 'svelte';
    import SvgIcon from '$lib/components/assets/SvgIcon.svelte';
    import {goto} from '$app/navigation';
    import type {DisplayWords} from '$lib/stores/displayWords';
    import type {CurrentWord} from '$lib/stores/currentWord';

    export let currentWord: CurrentWord
    export let displayWords: DisplayWords;

    const dispatch = createEventDispatcher();

    $: currentIndex = $displayWords.indexOf($currentWord!)

    $: prevWord = currentIndex > 0 ? $displayWords[currentIndex - 1] : null
    $: nextWord = currentIndex < $displayWords.length ? $displayWords[currentIndex + 1] : null


    function prev() {
        if (!prevWord) return
        //set word first plus routing neccessary for english search terms navigation
        currentWord.setCurrentWord(prevWord)
        goto(`/browse/${prevWord.id}`, {state: {scrollToCurrent: true}})
    }

    function next() {
        if (!nextWord) return
        currentWord.setCurrentWord(nextWord)
        //set word first plus routing neccessary for english search terms navigation
        goto(`/browse/${nextWord.id}`, {state: {scrollToCurrent: true}})
    }

    function close() {
        dispatch('close')
    }
</script>

<div>
    <button on:click={prev} disabled={!prevWord}>
        ‹
    </button>
    <button on:click={next} disabled={!nextWord}>
        ›
    </button>
    <button aria-label="close word card"
            on:click={close}
    >
        <SvgIcon name="x" width="16" height="16" viewBox="0 0 32 32" fill="white"/>
    </button>
</div>

<style>
    div {
        position: fixed;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
    }

    button:first-of-type {
        border-right: 2px solid var(--color-border);
    }

    button {
        width: 100%;
        display: grid;
        place-content: center;
        margin: 0;
        border-radius: 0;
        background: var(--color-lighter);
        color: var(--color-accent);
        font-size: 2.4rem;
        line-height: 1;
        padding: .25rem;
        font-weight: normal;
    }

    button:last-of-type {
        background: var(--color-accent);
        color: white;
    }

    button:disabled {
        color: var(--grey-90);
        font-weight: normal;
    }

</style>